// extracted by mini-css-extract-plugin
export default {"box":"PendingAlert_box","icon":"PendingAlert_icon","title":"PendingAlert_title","description":"PendingAlert_description","link":"PendingAlert_link"};